


















import { Component, Vue, Watch } from 'vue-property-decorator';
import { Route } from 'node_modules/vue-router/types';
import { getMyLogworks } from '@/services/api.service';
import { ILogworkData, ILogworkWithProject } from '@/lib/interfaces';
import { ruMonth } from '@/lib/helpers/common.helper';

@Component
export default class MyLogworks extends Vue {
  private year: number = new Date().getFullYear();
  private month: number = new Date().getMonth();
  private ruMonth = ruMonth;
  private data: {
    projectGroup: ILogworkWithProject[];
    dateGroup: ILogworkData[];
  } | null = null;

  private async updateData() {
    this.data = await getMyLogworks({
      month: this.month + 1,
      year: this.year,
    });
  }

  /** Года, которые начинаются со старта работы */
  private get years(): number[] {
    const res: number[] = [];
    const startWorkDate = new Date(this.$store.state.currentUser.start_work_date);
    for (let year = startWorkDate.getFullYear(); year <= new Date().getFullYear(); year++) {
      res.push(year);
    }
    return res;
  }

  private async beforeRouteEnter(to: Route, from: Route, next: (vm?: any) => void) {
    const curDate = new Date();
    const data = await getMyLogworks({
      month: curDate.getMonth() + 1,
      year: curDate.getFullYear(),
    });
    next((vm: MyLogworks) => {
      vm.data = data;
    });
  }
}
